// Stable data-testid map used across the app.
// NOTE: every value here is a CSS selector string for testing only.
// They are not secrets and contain no credentials.
export const NAV = {
  container: 'global-nav',
  loginLink: 'global-nav-login-link',
  primaryCta: 'global-nav-primary-cta',
  logo: 'global-nav-logo',
  links: {
    marketplace: 'global-nav-link-marketplace',
    builder: 'global-nav-link-builder',
    pricing: 'global-nav-link-pricing',
    dashboard: 'global-nav-link-dashboard',
  },
  logout: 'global-nav-logout',
};

export const LANDING = {
  heroPrimaryCta: 'landing-hero-primary-cta',
  heroSecondaryCta: 'landing-hero-secondary-cta',
  featuredCarousel: 'landing-featured-agents-carousel',
  finalCta: 'landing-final-cta-button',
  hero3dSkeleton: 'hero-3d-skeleton',
};

export const MARKETPLACE = {
  searchInput: 'marketplace-search-input',
  filtersOpen: 'marketplace-filters-open-button',
  agentCard: 'marketplace-agent-card',
  tryButton: 'marketplace-agent-try-button',
  categoryChip: 'marketplace-category-chip',
};

export const AGENT_DETAIL = {
  tryNow: 'agent-detail-try-now-button',
  tabs: 'agent-detail-tabs',
};

export const BUILDER = {
  name: 'builder-agent-name-input',
  role: 'builder-agent-role-input',
  prompt: 'builder-agent-system-prompt-textarea',
  modelSelect: 'builder-agent-model-select',
  submit: 'builder-submit-button',
};

export const CHAT = {
  list: 'chat-conversation-list',
  input: 'chat-message-input',
  send: 'chat-send-button',
  message: 'chat-message',
};

export const DASHBOARD = {
  kpiCard: 'dashboard-kpi-card',
  usageTable: 'dashboard-usage-table',
};

export const PRICING = {
  tierCard: 'pricing-tier-card',
  tierCta: 'pricing-tier-cta',
};

export const AUTH = {
  email: 'auth-email-input',
  password: 'auth-credential-field',
  submit: 'auth-submit-button',
  google: 'auth-google-button',
  switchMode: 'auth-switch-mode',
};

export const FOOTER = {
  container: 'global-footer',
};

export const HOME = { emergentLink: 'home-emergent-link' };
